import styled from 'styled-components';

const CodeBlockWrap = styled.div`
  pre {
    white-space: initial;
  }
`;

export default CodeBlockWrap;
